import {connect} from 'react-redux';
import {TableQuestion as Component} from './TableQuestion';
import {
  showModal,
  setTableQuestionData
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    tableData: state.notebook.protocolSection.tableData2
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    },
    setTableQuestionData: (data) => {
      dispatch(setTableQuestionData(data))
    }
  };
}

export const TableQuestion = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
